<template>
  <div class="contact">
    <div class="cont">
      <p
        class="title"
      >We will provide you with all the information needed to create your online poker club.</p>

      <el-form :model="ruleForm" :rules="rules" @submit.native.prevent="submitForm('ruleForm')" ref="ruleForm">
        <el-form-item prop="email">
          <el-col>
            <el-input placeholder="Enter Your Email Address" v-model="ruleForm.email"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item>
          <div class="btns center submit" @click="submitForm('ruleForm')">
            <span>YES! SIGN ME UP NOW</span>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    var checkEmail = (rule, value, callback) => {
      var reg = new RegExp(
        '^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$'
      )
      if (!reg.test(value)) {
        callback(new Error('Please enter a valid email address'))
      } else {
        callback()
      }
    }
    return {
      lock: false,
      ruleForm: {
        email: ''
      },
      rules: {
        email: [
          { required: true, message: 'Required', trigger: 'blur' },
          { validator: checkEmail, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid && !this.lock) {
          this.lock = true
          this.$axios.post('/poker-api/contact_us/submit_email', { email: this.ruleForm.email, client_type: 1 }).then((res) => {
            this.lock = false
            if (res.data && res.data.code === 0) {
              this.$router.push({
                name: 'poker-home-complete'
              })
            } else {
              alert(res.data.msg)
            }
          }).catch((error) => {
            this.lock = false
            alert('network issue, Please try again later.')
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss">
.cont .el-form {
  .el-input__inner {
    font-size: 24px;
    border-color: #aaaaaa;
    height: 54px;
    line-height: 54px;
    color: #54595f;
  }
  .el-form-item__error {
    padding-top: 10px;
    font-size: 16px;
  }
}
</style>

<style lang="scss" scoped>
.contact {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  .cont {
    width: 700px;
    .title {
      color: #54595f;
      font-size: 26px;
      line-height: 36px;
      margin: 100px auto 80px auto;
    }
    .el-form {
      width: 480px;
      margin: 0 auto;
      .btns {
        background-image: url("/pc/static/img/poker/btn.png");
        background-size: cover;
        background-position: center;
        margin: 80px auto 0px auto;
        width: 288px;
        height: 54px;
        cursor: pointer;
        span {
          font-size: 20px;
          color: #ffffff;
          line-height: 54px;
        }
      }
    }
  }
}
</style>
